import { Text } from "@codemirror/state"
import { NodeProp } from "@lezer/common";
import { SourceNode } from "../../../structures/nodes/source-node";
import { ASTNodeDescriptor, GroupedNodeList } from "../../../structures/nodes/ast-node/descriptor";
import { NodeBlueprint } from "./blueprint"

export class NodeGenerator {
    constructor(
        private node_blueprint: NodeBlueprint,
        readonly sourceText: Text
    ) {}

    group(node: ASTNodeDescriptor) {
        const plan = this.node_blueprint.plans[node.name];
        return plan?.group ? plan.group(node.sourceNodes, this) : [];
    }

    /**
     * Constructs an ASTNodeDescriptor from an SourceNode object using the blueprint.
     * All groups associated with the source node are included in the classList of the resulting ASTNodeDescriptor
     * @param sourceNode source
     * @returns an ASTNodeDescriptor object, or null if the syntaxNode type does not have an entry in the blueprint.
     */
    generateNode(sourceNode: SourceNode): ASTNodeDescriptor {
        const plan = this.node_blueprint.plans[sourceNode.name];

        const sourceNodes:GroupedNodeList = {}
        const sourceNodeTypes = plan ? plan.sourceNodeTypes : [sourceNode.name];
        sourceNodeTypes.forEach(type => {
            sourceNodes[type] = sourceNode.name == type ? [sourceNode] : sourceNode.getChildren(type);
        });
        const classList = (plan?.classList || []).concat(sourceNode.type.prop(NodeProp.group)||[]);
        return new ASTNodeDescriptor(sourceNode.name, classList, sourceNodes)
    }

    /**
     * Creates an ASTNodeDescriptor with the properties specified.
     * @param name the name of the node to be built
     * @param syntaxNodes the syntaxNodes from which this node is to be derived.
     * @returns an ASTNodeDescriptor object, or null if the blueprint does not have an entry for this node name.
     */
    constructNode(name: string, syntaxNodes:GroupedNodeList): ASTNodeDescriptor | null {
        const blueprint = this.node_blueprint.plans[name];
        if (!blueprint) return null;
        return new ASTNodeDescriptor(name, blueprint.classList||[], syntaxNodes);
    }
}